"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scopes = void 0;
var scopes = {
  // summary
  view_transaction_summary: "view_transaction_summary",
  view_treasury_summary: "view_treasury_summary",
  // transactions
  read_transactions: "read_transactions",
  download_transaction_reports: "download_transaction_reports",
  // settlements
  read_settlements: "read_settlements",
  read_tdr: "read_tdr",
  download_settlement_reports: "download_settlement_reports",
  // refunds
  read_refunds: "read_refunds",
  process_refunds: "process_refunds",
  download_refund_reports: "download_refund_reports",
  // payment-gateway
  manage_credentials: "manage_credentials",
  // payment-links
  create_payment_links: "create_payment_links",
  read_payment_links: "read_payment_links",
  update_payment_links: "update_payment_links",
  delete_payment_links: "delete_payment_links",
  // buttons
  create_buttons: "create_buttons",
  read_buttons: "read_buttons",
  update_buttons: "update_buttons",
  delete_buttons: "delete_buttons",
  // payment-handle
  create_payment_handles: "create_payment_handles",
  read_payment_handles: "read_payment_handles",
  update_payment_handles: "update_payment_handles",
  delete_payment_handles: "delete_payment_handles",
  // invoice
  create_invoices: "create_invoices",
  read_invoices: "read_invoices",
  update_invoices: "update_invoices",
  delete_invoices: "delete_invoices",
  create_invoice_customer: "create_invoice_customer",
  // update
  create_invoice_item: "create_invoice_item",
  // update
  // payouts
  maker: "maker",
  checker: "checker",
  manage_approval_flow: "manage_approval_flow",
  create_payout_transactions: "create_payout_transactions",
  download_invoice_payout: "download_invoice_payout",
  view_beneficiary_nb: "view_beneficiary_nb",
  download_beneficiary_nb: "download_beneficiary_nb",
  create_beneficiary_nb: "create_beneficiary_nb",
  update_beneficiary_nb: "update_beneficiary_nb",
  enable_beneficiary_nb: "enable_beneficiary_nb",
  disable_beneficiary_nb: "disable_beneficiary_nb",
  // settings
  user_profile: "user_profile",
  update_user_profile: "update_user_profile",
  manage_payment_notifications: "manage_payment_notifications",
  manage_treasury_notifications: "manage_treasury_notifications",
  manage_webhooks: "manage_webhooks",
  manage_checkouts: "manage_checkouts",
  manage_employees: "manage_employees",
  manage_outlets: "manage_outlets",
  manage_offers: "manage_offers",
  // chargeback
  manage_chargebacks: "manage_chargebacks",
  // neobanking
  read_account_request_nb: "read_account_request_nb",
  create_account_request_nb: "create_account_request_nb",
  read_account_details_nb: "read_account_details_nb",
  read_transaction_nb: " read_transaction_nb",
  add_transaction_meta_data_nb: "add_transaction_meta_data_nb",
  download_transaction_nb: "download_transaction_nb",
  read_summary_nb: "read_summary_nb",
  // neomarketplace
  read_account_nmp: "read_account_nmp",
  read_sales_list_nmp: "read_sales_list_nmp",
  read_sales_summary_nmp: "read_sales_summary_nmp",
  read_sales_detail_nmp: "read_sales_detail_nmp",
  read_settlement_list_nmp: "read_settlement_list_nmp",
  read_settlement_sumary_nmp: "read_settlement_sumary_nmp",
  read_settlement_details_nmp: "read_settlement_details_nmp",
  read_dispute_list_nmp: "read_dispute_list_nmp",
  read_dispute_summary_nmp: "read_dispute_summary_nmp",
  read_dispute_details_nmp: "read_dispute_details_nmp",
  update_dispute_status_nmp: "update_dispute_status_nmp",
  register_account_nmp: "register_account_nmp",
  // accountpayables
  read_bill_nb: "read_bill_nb",
  write_bill_nb: "write_bill_nb",
  read_bill_note_nb: "read_bill_note_nb",
  write_bill_note_nb: "write_bill_note_nb",
  read_vendor_nb: "read_vendor_nb",
  write_vendor_nb: "write_vendor_nb",
  read_bill_payment_nb: "read_bill_payment_nb",
  write_bill_payment_nb: "write_bill_payment_nb",
  // lending
  read_credits_nb: "read_credits_nb",
  download_credits_nb: "download_credits_nb",
  download_lending_document_nb: "download_lending_document_nb",
  write_credits_nb: "write_credits_nb",
  prepay_credits_nb: "prepay_credits_nb",
  merchant_info_nb: "merchant_info_nb",
  //settlements cycle
  read_settlement_cycle: "read_settlement_cycle",
  update_settlement_cycle: "update_settlement_cycle",
  //aggregator
  release_settlement: "release_settlement",
  //opgsp
  update_amlock_txn_details: "update_amlock_txn_details"
};
exports.scopes = scopes;